/**
 * SHL-1: distinct icons. Six sidebar items in the legacy app all shared
 * `icon-paper`, which made the nav unreadable at a glance.
 */
export type IconName =
  | 'dashboard'
  | 'requests'
  | 'appointments'
  | 'orders'
  | 'lawyers'
  | 'clients'
  | 'services'
  | 'emergencies'
  | 'taxonomies'
  | 'audit'
  | 'users'
  | 'promocodes'
  | 'consultations'
  | 'balances';

const PATHS: Record<IconName, string> = {
  dashboard: 'M3 3h7v8H3V3zm0 10h7v8H3v-8zm9-10h9v5h-9V3zm0 7h9v11h-9V10z',
  requests: 'M4 3h11l5 5v13a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm10 1.5V9h4.5M7 13h10M7 17h7',
  appointments:
    'M7 2v3M17 2v3M3 8h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z',
  orders: 'M3 6h18l-2 13H5L3 6zm3-3h12M9 10v5m6-5v5',
  lawyers: 'M12 3l9 5-9 5-9-5 9-5zm-6 8v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5',
  clients:
    'M12 12a4 4 0 100-8 4 4 0 000 8zm-8 9a8 8 0 0116 0M20 8a3 3 0 11-6 0 3 3 0 016 0z',
  services: 'M4 4h16v6H4V4zm0 10h16v6H4v-6zM8 7h8M8 17h8',
  emergencies: 'M12 3l10 18H2L12 3zm0 6v5m0 3h.01',
  taxonomies: 'M4 6h4v4H4V6zm0 8h4v4H4v-4zM12 8h8M12 16h8',
  audit: 'M9 4h6l1 3h3v13H5V7h3l1-3zm-1 8h8M8 16h5',
  users: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-8 9a8 8 0 0116 0',
  promocodes: 'M3 9V6a1 1 0 011-1h16a1 1 0 011 1v3a2 2 0 000 4v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3a2 2 0 000-4zm7-3v2m0 3v2m0 3v2',
  consultations: 'M4 5h16a1 1 0 011 1v9a1 1 0 01-1 1H9l-5 4V6a1 1 0 011-1zm4 5h.01M12 10h.01M16 10h.01',
  balances: 'M12 3v18M7 7h7a3 3 0 010 6H7m0 0h8a3 3 0 010 6H7',
};

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? 'h-4 w-4'}
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
